import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BrowserMultiFormatReader } from '@zxing/library';
import '../styles/BarcodeScanner.css'; // Mantén los mismos estilos

function Movimiento2Page() {
  const { scanCode } = useParams(); // Obtén scanCode desde la URL
  const [lastScannedCode, setLastScannedCode] = useState('');
  const [barcodeValue, setBarcodeValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isScannerActive, setIsScannerActive] = useState(false); // Estado para mostrar/ocultar el lector
  const [isManualMode, setIsManualMode] = useState(false);
  const [manualInput, setManualInput] = useState('');
  const navigate = useNavigate();
  const scannerRef = useRef(null);

  useEffect(() => {
    if (!isScannerActive || isManualMode) return;

    const codeReader = new BrowserMultiFormatReader();
    let activeStream;

    const initializeScanner = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'environment' },
        });

        activeStream = stream;

        if (scannerRef.current) {
          scannerRef.current.srcObject = stream;
        }

        // Inicia la lectura del código de barras
        codeReader.decodeFromVideoDevice(null, scannerRef.current, (result, error) => {
          if (result) {
            const scannedCode = result.getText();

            // Evita lecturas duplicadas
            if (scannedCode === lastScannedCode) {
              console.log('Código de barras duplicado detectado, ignorando...');
              return;
            }

            setLastScannedCode(scannedCode); // Actualiza el último código escaneado
            setBarcodeValue(scannedCode); // Muestra el código escaneado

            // Detén el lector y navega
            codeReader.reset();
            if (scanCode) {
              navigate(`/storage/movimiento/${scanCode.trim()}/${scannedCode.trim()}`);
            }
          }
        });
      } catch (err) {
        console.error('Error al inicializar el lector:', err);
        setErrorMessage('No se pudo acceder a la cámara. Por favor, revisa los permisos.');
      }
    };

    initializeScanner();

    return () => {
      if (activeStream) {
        activeStream.getTracks().forEach((track) => track.stop());
      }
      codeReader.reset(); // Restablece el lector al desmontar el componente
    };
  }, [isScannerActive, isManualMode, scanCode, navigate, lastScannedCode]);

  const handleManualSubmit = (e) => {
    e.preventDefault();
    if (!manualInput.trim()) {
      setErrorMessage('Por favor ingrese un código de barras');
      return;
    }
    navigate(`/storage/movimiento/${scanCode.trim()}/${manualInput.trim()}`);
  };

  const toggleMode = () => {
    setIsManualMode(!isManualMode);
    setIsScannerActive(false);
    setBarcodeValue('');
    setManualInput('');
    setErrorMessage('');
  };

  return (
    <div className="scanner-page">
      <h1 className="barcode-title">Escanea código de barras</h1>

      <button
        className="back-button"
        onClick={() => navigate('/storage/movimiento')}
        style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '8px' }}
      >
        <span className="arrow">&larr;</span>
      </button>

      <div style={{ marginBottom: '20px' }}>
        <button
          onClick={toggleMode}
          className="mode-toggle-button"
          style={{
            background: '#007BFF',
            color: '#FFF',
            border: 'none',
            borderRadius: '5px',
            padding: '10px 20px',
            cursor: 'pointer',
            marginBottom: '10px'
          }}
        >
          {isManualMode ? 'Cambiar a Escáner' : 'Cambiar a Entrada Manual'}
        </button>
      </div>

      {isManualMode ? (
        <div className="manual-input-container" style={{ padding: '20px' }}>
          <form onSubmit={handleManualSubmit}>
            <input
              type="text"
              value={manualInput}
              onChange={(e) => setManualInput(e.target.value)}
              placeholder="Ingrese código de barras"
              style={{
                padding: '10px',
                marginRight: '10px',
                borderRadius: '5px',
                border: '1px solid #ccc'
              }}
            />
            <button
              type="submit"
              style={{
                background: '#28a745',
                color: '#FFF',
                border: 'none',
                borderRadius: '5px',
                padding: '10px 20px',
                cursor: 'pointer'
              }}
            >
              Enviar
            </button>
          </form>
        </div>
      ) : (
        <>
          {!isScannerActive && ( // Muestra el botón si el lector no está activo
            <button
              className="start-scanner-button"
              onClick={() => setIsScannerActive(true)}
              style={{
                background: '#007BFF',
                color: '#FFF',
                border: 'none',
                borderRadius: '5px',
                padding: '10px 20px',
                cursor: 'pointer',
                margin: '20px 0',
              }}
            >
              Comenzar a escanear
            </button>
          )}

          {isScannerActive && (
            <div className="scanner-container">
              <video ref={scannerRef} className="scanner-video" autoPlay playsInline></video>
              <div className="scanner-overlay">
                <p className="scanner-instructions">Mantén el código de barras dentro del cuadro</p>
                <div className="scanner-box"></div>
              </div>
            </div>
          )}
        </>
      )}

      {barcodeValue && (
        <p className="scanner-output">
          <strong>Código Escaneado:</strong> {barcodeValue}
        </p>
      )}
      {errorMessage && <p className="scanner-error">{errorMessage}</p>}
    </div>
  );
}

export default Movimiento2Page;
